import { render, staticRenderFns } from "./ConsumersChart.vue?vue&type=template&id=58213215&scoped=true&"
import script from "./ConsumersChart.vue?vue&type=script&lang=js&"
export * from "./ConsumersChart.vue?vue&type=script&lang=js&"
import style0 from "./ConsumersChart.vue?vue&type=style&index=0&id=58213215&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58213215",
  null
  
)

export default component.exports